import { ref, watch, onMounted } from "@vue/composition-api";
import { DefaultConfigs } from "../../services/DefaultConfigs";

export default function useLineChartExtremes(lineChartDataSetRef, availableWidthRef, availableHeightRef, xRef, yRef, xBandwidthRef) {
  const extremes = ref([]);

  const updateExtremes = () => {
    if (!xRef?.value || !yRef?.value) {
      extremes.value = [];
      return;
    }

    const halfXBand = xBandwidthRef.value / 2;

    extremes.value = lineChartDataSetRef.value
      .filter(d => d.x != null && d.y != null)
      .map((d, i) => {
        const upperExtreme = yRef.value(d.y - d.extreme.upper) - yRef.value(d.y);
        const lowerExtreme = -(yRef.value(d.y - d.extreme.lower) - yRef.value(d.y));
        const color = d.setColor;

        return {
          id: `error-${d.x}-${i}`,
          x: xRef.value(d.x) + halfXBand,
          y: yRef.value(d.y),
          top: {
            x1: -DefaultConfigs.LineChart.extremeWidth,
            x2: DefaultConfigs.LineChart.extremeWidth,
            y1: upperExtreme,
            y2: upperExtreme,
            color: upperExtreme ? color : "none",
          },
          bottom: {
            x1: -DefaultConfigs.LineChart.extremeWidth,
            x2: DefaultConfigs.LineChart.extremeWidth,
            y1: lowerExtreme,
            y2: lowerExtreme,
            color: lowerExtreme ? color : "none",
          },
          vertical: {
            x1: 0,
            x2: 0,
            y1: upperExtreme,
            y2: lowerExtreme,
            color: upperExtreme || lowerExtreme ? color : "none",
          },
          strokeWidth: DefaultConfigs.LineChart.strokeWidth,
        };
      });
  };

  watch([lineChartDataSetRef, availableWidthRef, availableHeightRef, xRef, yRef], updateExtremes);

  onMounted(updateExtremes);

  return { extremes };
}
